<template>
  <div class="page">

    <div class="page__header">
      <div class="page__header-title">
        <div class="row">
          <div class="col-md-6">
            Programs
            <div class="page__header-subtitle">Manage Corporate Programs</div>
          </div>
          <div class="col-md-6 text-right">
            <b-button variant="success" @click="openEditModal(null, $event.target)" class="mr-1">
              Create New Program
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <div class="page__body">

      <div class="card bg-dark shadow border-0">
        <div class="card-body px-0 rounded overflow-auto">

          <div class="b2b-table">

            <b-table
                striped
                hover
                :items="rows"
                :fields="fields"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :busy="isLoading">

              <template #table-busy>
                <div class="text-center text-white my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong class="ml-3">Loading...</strong>
                </div>
              </template>

              <template #cell(thumbnail)="data">
                <div class="w-100">
                  <img :src="data.item.thumbnail ? data.item.thumbnail : defaultThumbnail" :alt="data.item.name" width="100%">
                </div>
              </template>

              <template #cell(programVideos)="data">
               <div class="row">
                 <div class="col-md-2" v-for="video in data.item.programVideos" :key="video.id">
                   <div class="video-item">
                     <div class="video-image mb-2">
                       <img :src="video.thumbnail" :alt="video.title" width="100%">
                     </div>
                     <div class="video-title">{{ video.title }}</div>
                   </div>
                 </div>
               </div>
              </template>

              <template #cell(action)="data">
                <b-button size="sm" @click="openEditModal(data.item, $event.target)" class="mr-1">
                  Edit
                </b-button>
              </template>

            </b-table>

            <div v-if="!isLoading && rows.length === 0">
              <hr/>
              <noData>No Data Available</noData>
            </div>

            <div class="px-4">
              <div class="d-inline-block mr-4">
                <b-form-row>
                  <b-col><label :for="'page-size'">Page Size:</label></b-col>
                  <b-col>
                    <b-form-input
                        id="page-size"
                        size="sm"
                        class="page-size"
                        v-model="pageSize"
                        placeholder="Page Size"
                        :min="1"
                    ></b-form-input>
                  </b-col>
                </b-form-row>
              </div>
              <div class="d-inline-block">
                <b-pagination
                    pills
                    size="sm"
                    v-model="page"
                    :per-page="pageSize"
                    :total-rows="totalRecords"
                ></b-pagination>
              </div>
            </div>

          </div>

        </div>
      </div>

      <!-- Edit modal -->
      <b-modal
          class="text-light"
          dialog-class="b2b-access-code-dialog border-0"
          content-class="bg-dark border-0"
          header-class="text-light"
          id="edit-program-modal"
          :title="form.name != null? 'Edit: ' + form.name : 'New Program'"
          ok-title="Save"
          @ok="save"
          @cancel="resetEditModal"
          @hide="resetEditModal"
          >

        <b-form @submit="onSubmit">

          <b-form-group
              id="input-group-1"
              label="Program ID:"
              label-for="input-1"
              class="textColor"
              description="Unique 6 digit alpha numeric ID of a program">
            <b-form-input
                id="input-1"
                v-model="form.id"
                type="text"
                placeholder="Enter Program ID"
                :disabled="!form.isNew"
                required
            ></b-form-input>
          </b-form-group>

          <b-form-group
              id="input-group-2"
              label="Program Name:"
              label-for="input-2"
              class="textColor"
              description="(eg. Week 1, Simple Workouts)">
            <b-form-input
                id="input-1"
                v-model="form.name"
                type="text"
                placeholder="Enter Program Name"
                required
            ></b-form-input>
          </b-form-group>
            <b-form-group label="Program Thumbnail" label-size="sm" label-class="form-label" class="textColor"
          ><b-row style="align-items: center">
            <b-col cols="8"
              ><b-form-input
                v-model="thumbnailTitle"
                required
                size="sm"
                trim
                disabled
                maxlength="50"
                placeholder="Upload thumbnail"
              ></b-form-input></b-col
            ><b-col cols="4">
              <b-button
                ref="thumbnailTitle"
                size="sm"
                class="custom-button select"
                @click="
                  $refs.thumbnail.$el.querySelector('input[type=file]').click()
                "
                ><p>SELECT</p></b-button
              ></b-col
            ></b-row
          >
          <b-form-file
            class="d-none"
            ref="thumbnail"
            v-model="thumbnail"
            :state="Boolean(thumbnail)"
            placeholder="Select Files"
            size="sm"
            accept="image/*"
            required
            @input="handleImageChange($event)"
          ></b-form-file>
        </b-form-group>

          <b-form-group
              id="input-group-3"
              label="Program Author:"
              label-for="input-3"
              class="textColor"
              description="Tenant who is creating this program (eg. EliteFir.AI Premium)">
            <multiselect
                class="bg-light rounded"
                v-model="form.author"
                placeholder="Select Program Author"
                label="name"
                track-by="id"
                :options="authors"
                :allow-empty="false">
            </multiselect>
          </b-form-group>
          <b-form-group
              id="input-group-6"
              label="Program Active Days:"
              label-for="input-6"
              class="textColor"
              description="Program valid for number of days (eg: 7)">
            <b-form-input
                id="input-6"
                v-model="form.days"
                type="number"
                min="1"
                max="999"
                placeholder="Enter Program active days"
                required
            ></b-form-input>
          </b-form-group>
          <b-form-group
              id="input-group-dynamic-date"
              label="Dynamic Date:"
              label-for="input-dynamic-date"
              class="textColor"
              description="Program start date should be dynamic?"
          >
            <b-form-checkbox id="input-dynamic-date" switch size="lg" v-model="form.isDynamicDate"></b-form-checkbox>
          </b-form-group>
          <b-form-group
              id="input-group-4"
              label="Program Description:"
              label-for="input-4"
              class="textColor"
              description="Program description">
             <b-form-textarea
                id="textarea"
                v-model="form.description"
                placeholder="Enter program description"
                maxlength="500"
                rows="3"
                max-rows="6"
                required
              ></b-form-textarea>
          </b-form-group>

          <b-form-group
              id="input-group-5"
              label="Program Videos:"
              label-for="input-5"
              class="textColor"
              description="">
            <div>
              <multiselect
                  class="bg-light rounded"
                  v-model="form.videos"
                  placeholder="Select Multiple Videos"
                  label="title"
                  track-by="id"
                  :options="videos"
                  :clear-on-select="false"
                  :close-on-select="false"
                  :multiple="true">
              </multiselect>
              <div class="row mt-3">
                <div class="col-md-3 mb-3" v-for="video in form.videos" :key="video.id">
                  <div class="video-item">
                    <div class="video-image mb-2">
                      <img :src="video.thumbnail" :alt="video.title" width="100%">
                    </div>
                    <div class="video-title">{{ video.title }}</div>
                  </div>
                </div>
              </div>
            </div>
          </b-form-group>

        </b-form>

      </b-modal>

    </div>
  </div>
</template>

<script>
import noData from "@/module_admin/components/NoDataAvailable";
import b2bService from "@/module_admin/api/b2b-admin-service";
import Multiselect from 'vue-multiselect'
import S3Url from "../s3upload/getSignedURL";
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers(
  "admin/trainerVideosView"
);
import defaultThumbnail from "@/assets/images/defaultThumbnail.png"
import Swal from "sweetalert2";

export default {
  name: "Programs",
  data() {
    return {
      page: 1,
      pageSize: 50,
      sortBy: '',
      sortDesc: false,
      defaultThumbnail: defaultThumbnail,
      fields: [
        { key: 'id', label: 'Program ID' },
        { key: 'name', label: 'Name' },
        { key: 'thumbnail', label: 'Program Thumbnail' },
        { key: 'author', label: 'Author' },
        { key: 'programVideos', label: 'Videos' },
        { key: 'action', label: 'Actions' }
      ],
      rows: [],
      totalPages: 0,
      totalRecords: 0,
      isLoading: false,
      thumbnailChanged: false,
      thumbnailTitle: null,
      thumbnailFile: null,
      thumbnail: null,
      form: {
        id: null,
        name: null,
        thumbnailURL: null,
        author: null,
        videos: [],
        isNew: true,
        days: null,
        description: "",
        isDynamicDate: false,
      },
      authors: [],
      videos: [],
    }
  },
  components: {
    noData,
    Multiselect
  },
  watch: {
    sortBy() {
      this.loadData();
    },
    sortDesc() {
      this.loadData();
    },
    page() {
      this.loadData();
    },
    pageSize() {
      if (this.pageSize !== 0) {
        this.loadData();
      }
    }
  },
  methods: {
    ...mapActions(["getS3Cred"]),
    openEditModal(item, button) {
      this.thumbnailURL = null;
      this.thumbnailTitle = null;
      if (item != null) {
        this.form.id = item.id;
        this.form.name = item.name;
        this.form.author = { id: item.authorID, name: item.author };
        this.thumbnailURL = item.thumbnail ? item.thumbnail : null;
        this.thumbnailTitle = item.thumbnail ? item.thumbnail.substr(
          item.thumbnail.indexOf("/thumbnails/") + "/thumbnails/".length
      ): null;
        this.form.videos = item.programVideos;
        this.form.isNew = false;
        this.form.description = item.description ? item.description : "";
        this.form.days = item.days ? item.days : 0;
        this.form.isDynamicDate = !!item.isDynamicDate;
      }
      else {
        this.form.id = this.generateProgramID();
      }
      this.$root.$emit('bv::show::modal', 'edit-program-modal', button);
    },
    handleImageChange(e) {
      this.thumbnailChanged = true;
      this.thumbnailTitle = e.name;
      this.thumbnailFile = e;
      const reader = new FileReader();

      reader.onload = (e) => {
        this.thumbnail = e.target.result;
      };
      reader.readAsArrayBuffer(e);
    },
    resetEditModal() {
      this.form = {
        id: null,
        name: null,
        thumbnailURL: null,
        author: null,
        videos: [],
        isNew: true,
        days: null,
        description: "",
        isDynamicDate: false,
      };
    },
    async save() {
      if (this.form.id === null) {
        alert('Program ID cannot be blank');
        return;
      }
      if (this.form.author === null) {
        alert('Program Author cannot be blank');
        return;
      }
      if (!this.thumbnailTitle) {
        alert('Program thumbnail cannot be blank');
        return;
      }
      if(!this.form.days) {
        alert('Program active days cannot be blank');
        return;
      }
      if(+this.form.days < 0 && +this.form.days > 9999) {

        alert('Please enter the valid active days');
        return;
      } 
      if(this.form.description.trim() == "") {
        alert('Program details cannot be blank');
        return;
      }
      let formData = {...this.form};
      formData.thumbnailURL = this.thumbnailURL;

      if (this.thumbnailChanged) {
        await this.getS3Cred();
        let s3Cred = this.$store.state.admin.trainerVideosView.s3Cred;
        //upload thumbnail to s3
        let thumbResponse = await S3Url.getS3Url(
          s3Cred,
          this.thumbnailFile,
          this.thumbnail,
          "thumbnails"
        );
        formData.thumbnailURL = thumbResponse.Location;
        this.thumbnailChanged = false;
      }
      b2bService.createUpdateProgram(formData).then((resp) => {
        if (resp.code === 200) {
          if (formData.isNew) {
            // this.makeToast('success', 'Success', 'New program created successfully')
            Swal.fire({
            title: "New program created successfully",
            icon: "success",
            confirmButtonText: "OK",
          });
          }
          else {
            // this.makeToast('success', 'Success', `${formData.name} update successfully`)
            Swal.fire({
            title: `${formData.name} update successfully`,
            icon: "success",
            confirmButtonText: "OK",
          });
          }
          this.loadData();
        }
        else {
          if (formData.isNew) {
            this.makeToast('danger', 'Error', 'Failed to create new program')
          }
          else {
            this.makeToast('danger', 'Error', `Failed to update ${formData.name}`)
          }
        }
      }).finally(() => {});
    },
    loadLocalConfig(onlySave = false) {
      const localConfig = localStorage.getItem('config');
      let config = (localConfig) ? JSON.parse(localConfig) : {};
      if (config?.b2bProgramsPageSzie && !onlySave) {
        this.pageSize = config.b2bProgramsPageSzie;
      }
      else {
        config.b2bProgramsPageSzie = this.pageSize;
      }
      localStorage.setItem('config', JSON.stringify(config));
    },
    onSubmit(event) {
      event.preventDefault();
      this.save();
    },
    loadDropdownItems() {
      b2bService.getProgramDropdownItems().then((resp) => {
        if (resp.code === 200) {
          const data = resp.data;
          this.authors = data.authors;
          this.videos = data.videos;
        }
      })
    },
    loadData() {
      const params = {
        page: this.page,
        pageSize: this.pageSize,
        sortBy: this.sortBy,
        sortDirection: this.sortDesc ? 'DESC' : 'ASC'
      };
      b2bService.getPrograms(params).then((resp) => {
        if (resp.code === 200) {
          const data = resp.data;
          this.rows = data.rows;
          this.totalPages = data.totalPages;
          this.totalRecords = data.totalRecords;
        }
      }).finally(() => {
        this.isLoading = false;
      });
      this.loadLocalConfig(true);
    },
    makeToast(variant, title, message) {
      this.$bvToast.toast(message, {
        title: title,
        variant: variant,
        solid: true
      });
    },
    generateProgramID(length = 6) {
      let result = '';
      const characters = 'ABCDEFGHILKMNOPQRSTUVWXYZ0123456789';
      const charactersLength = characters.length;
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() *
            charactersLength));
      }
      return result;
    }
  },
  mounted() {
    this.loadLocalConfig();
    this.isLoading = true;
    this.loadData();
    this.loadDropdownItems();
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
.textColor{
  color:white
}
</style>
